const obj = {
  btn_get_started: {
    fontSize: "16px",
    letterSpacing: "1px",
    display: "inline-block",
    padding: "10px 30px",
    borderRadius: "50px",
    textDecoration: "none",
    color: "var(--contact_color)",
    opacity: "1",
    transition: "0.4s ease",
    fontWeight: "500 !important",
    backgroundColor: "transparent",
  },
}
export default obj
